
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import Dator from "@/utils/censor.js";

export default {
name: "register",
components: {
XInput,
Group,
Picker,
Popup
},

data() {
return {
iconNone: require("@/assets/image/icon/dele.png"),
iconAll: {
iconLogo: require("@/assets/image/icon/logo.png"),
wechatLogo: require("@/assets/image/icon/wechat_logo.png"),
facebookLogo: require("@/assets/image/icon/facebook_logo.png"),
googleLogo: require("@/assets/image/icon/google_logo.png")
},
formD: {
email: "",
code: "",
passw: "",
passwConfirm: "",
nickname: ""
},
second: 0,
countor: null,
isNative: false,
userSeeShow: true
};
},
mounted: function() {

},
methods: {

onClickLeft(){
this.$router.go(-1)
},

sendEmailCode() {
let dator = new Dator.dator();
dator.add(this.formD.email, [
{ strategy: "isEmpty", errMsg: this.$t("FORGET_LANG.inputEmail") },
{ strategy: "checkEmail", errMsg: this.$t("FORGET_LANG.emailErr") }
]);

if (dator.getErrmsg()) {
this.$toast.text(dator.getErrmsg());
return;
}

let postD = {
email: this.formD.email
};
this.GLOBAL_.ccRequest.doAxios(this.CONFIG.USER.EMAILVERIFICATIONCODE, postD, "POST")
.then(res => {

this.second = 60;
this.startCounting();
this.$toast.text(this.$t("LOGIN_LANG.sendCodeSuccess"));
})
.catch(err => {

let res = err.response;
this.$toast.text(this.$t("FORGET_LANG.getCodeErr") + "：" + res.data.message);
});
},


startCounting() {
let _this = this;
if (this.second > 0) {
this.countor = setInterval(() => {

_this.second -= 1;
if (_this.second === 0) {
clearInterval(_this.countor);
}
}, 1000);
} else {
clearInterval(_this.countor);
}
},

gotoPage(page) {
let obj = {};
obj["path"] = this.UTILS.splitUrl(page);
obj.router = this.$router;
this.GLOBAL_.ccApp.openTo(obj);
},

stopCounting() {
clearInterval(_this.countor);
},


doRegist() {





let dator = new Dator.dator();
dator.add(this.formD.email, [
{ strategy: "isEmpty", errMsg: this.$t("FORGET_LANG.inputEmail") },
{ strategy: "checkEmail", errMsg: this.$t("FORGET_LANG.emailErr") }
]);

dator.add(this.formD.code, [
{ strategy: "isEmpty", errMsg: this.$t("FORGET_LANG.inputCode") },
{
strategy: "checkStringFormat:4:1",
errMsg: this.$t("FORGET_LANG.CodeErr")
}
]);

dator.add(this.formD.passw, [
{ strategy: "isEmpty", errMsg: this.$t("FORGET_LANG.inputPassThree") },
{
strategy: "checkPassworld",
errMsg: this.$t("FORGET_LANG.passMessage")
}
]);

dator.add(this.formD.passwConfirm, [
{ strategy: "isEmpty", errMsg: this.$t("FORGET_LANG.inputPassFour") },
{
strategy: "checkPassworld",
errMsg: this.$t("FORGET_LANG.passMessage")
}
]);

dator.add(this.formD.passwConfirm, [
{
strategy: "checkEqual:" + this.formD.passw,
errMsg: this.$t("FORGET_LANG.twoPassErr")
}
]);

dator.add(this.formD.nickname, [
{
strategy: "isEmpty",
errMsg: this.$t("REGISTER_LANG.inputAppellationTwo")
},
{
strategy: "checkStringFormat:2:4",
errMsg: this.$t("REGISTER_LANG.appellationMinLength")
},
{
strategy: "checkStringFormat:12:2",
errMsg: this.$t("REGISTER_LANG.appellationMaxLength")
},
{
strategy: "checkName",
errMsg: this.$t("REGISTER_LANG.appellationErr")
}
]);

if (dator.getErrmsg()) {
this.$toast.text(dator.getErrmsg());
return;
}

this.$toast.loading();


let postD = {
password: this.formD.passw,
email: this.formD.email,
code: this.formD.code,
nickName: this.formD.nickname
};

this.GLOBAL_.ccRequest.doAxios(this.CONFIG.USER.REGISTER, postD, "POST")
.then(res => {
console.log('註冊成功', res)
this.$toast.close();
this.$toast.text(this.$t("REGISTER_LANG.regSuccess"));

let obj = res.data.session;
obj["userInfo"] = {
email: res.data.userInfo.email,
id: res.data.userInfo.id,
nickname: res.data.userInfo.nickname
};

this.LOGIN.setSession(obj).then(r => {
console.log('跳轉', r)
setTimeout(() => {

let obj = {
path: "my"
};
this.GLOBAL_.ccApp.navigateTo(this.$router, obj);

}, 1000);
})
.catch(err => {
this.$toast.text(this.$t("REQUEST_ERR_LANG_7"));

});
})
.catch(err => {
if (this.isNative) {
native.hideLoading();
}

let res = err.response;
this.$toast.text(this.$t("REGISTER_LANG.regFail") + ":" + res.data.message);
});
}
}
};



// WEBPACK FOOTER //
// ./src/pages/login/register.vue